import { PageInfo } from './page-info';

export class PaginatorParams {
  totalItems: number;
  pageInfo: PageInfo;

  withPage(page: number, itemsPerPage): PaginatorParams {
      this.pageInfo = new PageInfo(page, itemsPerPage);
      return this;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/model/pagination/paginator-params.ts